
import Header from '../../components/admin/header/Header';
import Content from '../../components/admin/popup/Content';

export default function Popup() {


  return (
    <>
      <Header></Header>
      <div className="content-wrapper">
        <div className="titleNav">팝업관리</div>
        
        <div className="">
          <Content />
        </div>
      </div>
    </>
  );
}